import React from 'react';

import {DateFormat, format} from '../../../../util/date';
import * as CGReact from '../../../react';
import type * as Panel2 from '../panel';
import {Panel2Loader} from '../PanelComp';
import * as S from '../PanelString.styles';
import {type inputType} from './common';

type PanelDateProps = Panel2.PanelProps<typeof inputType>;

const PanelDate: React.FC<PanelDateProps> = props => {
  const nodeValueQuery = CGReact.useNodeValue(props.input as any);
  if (nodeValueQuery.loading) {
    return <Panel2Loader />;
  }

  if (nodeValueQuery.result == null) {
    return <div>-</div>;
  }

  // TODO: when timestamp units other than ms are supported, need to do conversion.
  const date = new Date(nodeValueQuery.result as Date | number);
  const dateS = format(date, DateFormat.YYYY_MM_DD_HH_MM_SS_DASHES);

  return (
    <S.StringContainer>
      <S.StringItem>{dateS}</S.StringItem>
    </S.StringContainer>
  );
};

export default PanelDate;
